import { withMarkdownNormalization } from './normalization';
import { leafBlockTypes, } from './normalization/flatten-mdast';
import { withMarkdownInsertData } from './insertData';
export { default as decorate } from './decorate';
export { TasquetMarkdownEditor } from './command';
export { useOnCopy, useOnCut } from './event-handlers/onCopyCut';
export { useOnKeyDown } from './event-handlers/onKeyDown';
export * from './serialize';
export { default as renderers } from './renderers';
export * from './element-factories';
const topLevelElementTypes = leafBlockTypes;
export const isTopLevel = (element) => typeof element.type === 'string' &&
    topLevelElementTypes.includes(element.type);
export const isEmptyElement = (element) => element.type === 'empty' || element.type === 'placeholder';
export const isLine = (element) => element.type === 'line';
export const withMarkdown = (editor, listeners = {}) => {
    // TODO: Is this correct?
    if (typeof editor.insertData === 'function') {
        editor = withMarkdownInsertData(editor);
    }
    return withMarkdownNormalization(editor, listeners);
};
//# sourceMappingURL=index.js.map